// El navegador recordado del segundo factor de los admins (28-10, `core/segundo_factor.py`).
// El servidor da un testigo al pasar el código con «Recordar este dispositivo»; mandándolo al
// entrar, ese navegador no vuelve a pedir el código en 30 días. Uno por correo: en el mismo
// ordenador pueden entrar dos admins.

const CLAVE = 'segundo_factor_dispositivo:';

const normalizar = (email) => (email || '').trim().toLowerCase();

export function dispositivoRecordado(email) {
    try {
        return localStorage.getItem(CLAVE + normalizar(email)) || undefined;
    } catch {
        return undefined;
    }
}

export function recordarDispositivo(email, testigo) {
    if (!testigo) return;
    try {
        localStorage.setItem(CLAVE + normalizar(email), testigo);
    } catch {
        // Sin almacenamiento (ventana privada): pedirá el código la próxima vez, nada más.
    }
}

// Solo cifras, como mucho seis: el campo admite pegar «123 456».
export const soloCifras = (texto) => (texto || '').replace(/\D/g, '').slice(0, 6);
